import React from 'react';
import { injectGlobal } from 'styled-components';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
} from '../../coreui';

import Nav from './components/Nav';

import {
  propTypeStrings,
  geoStrings,
  investmentTypeStrings,
  propTypeStringsMR2,
  marketTierStrings,
} from './data/strings';

export const chartCSS = injectGlobal`
  .highcharts-axis-line {
    display: none;
  }
  .highcharts-container text  {
    font-family: "Gotham SSm A", "Gotham SSm B", Helvetica, Arial, sans-serif;
    color: #202020;
  }
`;

const PortfolioStats = ({
  assets,
  id,
}) => {
  const stats = {
    first: {},
    second: {},
    third: {},
  };
  let tabs = [];
  let strings = [];
  switch (id) {
    case 274949:
      tabs = [
        'Property Type',
        'Market Tier',
        'Geographic Region',
      ];
      strings = [
        propTypeStringsMR2,
        marketTierStrings,
        geoStrings,
      ];
      assets.map(
        (asset) => {
          if (!stats.third[asset.region.value]) {
            stats.third[asset.region.value] = {};
            stats.third[asset.region.value].stat = 0;
            stats.third[asset.region.value].label = asset.region.label;
          }
          stats.third[asset.region.value].stat += 1;

          if (!stats.first[asset.propertyTypeStat]) {
            stats.first[asset.propertyTypeStat] = {};
            stats.first[asset.propertyTypeStat].stat = 0;
            stats.first[asset.propertyTypeStat].label = asset.propertyTypeStat;
          }
          stats.first[asset.propertyTypeStat].stat += 1;

          if (!stats.second[asset.marketTier]) {
            stats.second[asset.marketTier] = {};
            stats.second[asset.marketTier].stat = 0;
            stats.second[asset.marketTier].label = asset.marketTier;
          }
          stats.second[asset.marketTier].stat += 1;
          return null;
        },
      );
      break;
    default:
      tabs = [
        'Property Type',
        'Geographic Region',
        'Investment Type',
      ];
      strings = [
        propTypeStrings,
        geoStrings,
        investmentTypeStrings,
      ];
      assets.map(
        (asset) => {
          if (!stats.second[asset.region.value]) {
            stats.second[asset.region.value] = {};
            stats.second[asset.region.value].stat = 0;
            stats.second[asset.region.value].label = asset.region.label;
          }
          stats.second[asset.region.value].stat += asset.weight;

          if (!stats.first[asset.propertyTypeStat]) {
            stats.first[asset.propertyTypeStat] = {};
            stats.first[asset.propertyTypeStat].stat = 0;
            stats.first[asset.propertyTypeStat].label = asset.propertyTypeStat;
          }
          stats.first[asset.propertyTypeStat].stat += asset.weight;

          if (!stats.third[asset.investmentType]) {
            stats.third[asset.investmentType] = {};
            stats.third[asset.investmentType].stat = 0;
            stats.third[asset.investmentType].label = asset.investmentType;
          }
          stats.third[asset.investmentType].stat += asset.weight;
          return null;
        },
      );
      break;
  }

  return (
    <ExtendedFlex
      justify="center"
      align="center"
      flexDirection="column"
      height="100%"
      pb={80}
      bg="gray.0"
      w={1}
    >
      <Nav
        stats={stats}
        tabs={tabs}
        strings={strings}
      />
    </ExtendedFlex>
  );
};

PortfolioStats.propTypes = {
  assets: PropTypes.array,
  id: PropTypes.number,
};

export default PortfolioStats;
